import React, { useEffect, useRef, useState } from "react";
import Card from "../ui/Card";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import { CopyIcon } from "../utils/Icons";
import { drawPrice, getSaved } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Row from "../ui/Row";
import dayjs from "dayjs";

export default function CustomerDetails(props) {

    const { selected = {}, setSelected = () => { }, edit = false, route = "" } = props;
    const refs = useRef([]);
    const [index, setIndex] = useState(getSaved("customers_start_field") || "attention");

    const {
        address_1 = "634 Thorneloe Road",
        address_2 = "",
        attention = "start date: Aug24 2020",
        bill_to = "Bill To",
        bo = "N",
        cancel = 0,
        city = "",
        combine_po = "Y",
        communication_preference = "", // pref
        country = "CANADA",
        credit_limit = 0,
        discount = 30,
        edi_codes = "",
        email = "",
        enter_date = "2020-09-28",
        fax = "", // phone3 
        frequent_buyer = true,
        frequent_buyer_point = 0,
        frequent_buyer_recipient = "",
        get_deposit = false,
        interest_1 = "STAFF", // class
        interest_2 = "",
        interest_3 = "",
        interest_4 = "",
        last_order_date = "2024-07-12",
        location = "0",
        name = "Hunter, Mike",
        note = "start date: Aug24 2020",
        note_keynum = "",
        notes = "BM STAFF",
        over_due = " ",
        person_id = "0193046b-be5b-7501-8365-68de0d568519",
        phone = "",
        phone_2 = "",
        postal_code = "V1W 4P6",
        province = "BC",
        rep = "",
        sales_3 = 43,
        sales_last = 14,
        sales_this = 9,
        san = "", //ol account
        ship_to = "104303",
        ship_via = "",
        shop = "", // custType
        tax_exempt = "",
        tax_exempt_2 = "",
        tax_group_code = "",
        term = "",
        web_access = " "
    } = selected;



    const tabs = [
        { key: "attention", autoselect: true },
        { key: "ship_to", autoselect: true },
        { key: "shop", autoselect: true },
        { key: "name", autoselect: true },
        { key: "phone", autoselect: true },
        { key: "phone_2", autoselect: true },
        { key: "fax", autoselect: true },
        { key: "email", autoselect: true },
        { key: "communication_preference", autoselect: true },
        { key: "address_1", autoselect: true },
        { key: "address_2", autoselect: true },
        { key: "city", autoselect: true },
        { key: "province", autoselect: true },
        { key: "postal_code", autoselect: true },
        { key: "country", autoselect: true },
        { key: "san", autoselect: true },
        { key: "rep", autoselect: true },
        { key: "interest_1", autoselect: true },
        { key: "interest_2", autoselect: true },
        { key: "interest_3", autoselect: true },
        { key: "interest_4", autoselect: true },
        { key: "bill_to", autoselect: true },
        { key: "discount", autoselect: true },
        { key: "tax_group_code", autoselect: true },
        { key: "credit_limit", autoselect: true },
        { key: "tax_exempt", autoselect: true },
        { key: "tax_exempt_2", autoselect: true },

    ];

    const editProps = (index) => ({
        onFocus: () => setIndex(index),
        ref: (e) => (refs.current[index] = e),
        edit: (edit && tabs.find(item => item.key === index)),
        controlled: true,
        autoselect: tabs.find(item => item.key === index)?.autoselect || false,
        onChange: (e) => {
            setSelected({ ...selected, [index]: e })
        }
    });

    const next = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex !== -1 && currentIndex < tabs.length - 1) { return setIndex(tabs[currentIndex + 1].key); }
        return setIndex(tabs[0].key);
    };

    const prev = () => {
        const currentIndex = tabs.findIndex(tab => tab.key === index);
        if (currentIndex > 0) { return setIndex(tabs[currentIndex - 1].key); }
        return setIndex(tabs[tabs.length - 1].key);
    };


    const handleEnter = () => {


        switch (index) {
            case "tax_group_code":
                alert("Called")
                break;
        }
    }


    useEffect(() => {

        if (refs?.current[index]) {
            refs.current[index].focus();
        }
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { } },
            { key: KBD.ENTER, action: (e) => { alert("eee") } },
        ];
        const cleanup = listen(route, actions, false, [KBD.ENTER]);
        return cleanup;
    }, [index]);




    const drawCard = () => {
        return (
            <>

                <Space grow size={8}>
                    <Label shrink={false} width={37}>Attn</Label>
                    <Input grow {...editProps("attention")} maxLength={20} value={attention} width={250} />
                    <Label><nobr>Act#</nobr></Label>
                    <Input {...editProps("ship_to")} maxLength={8} uppercase value={ship_to} width={140} />
                    <Label><nobr>CustType</nobr></Label>
                    <Input {...editProps("shop")} style={{ "textAlign": "center" }} value={shop} width={25} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Name</Label>
                    <Input grow {...editProps("name")} maxLength={35} value={name} width={659} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Phone</Label>
                    <Input shrink={false} grow {...editProps("phone")} maxLength={16} value={phone} width={170} />
                    <Label width={37}>Phn2</Label>
                    <Input {...editProps("phone_2")} grow maxLength={16} value={phone_2} width={170} />
                    <Label width={37}>Phn3</Label>
                    <Input {...editProps("fax")} grow maxLength={16} value={fax} width={170} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Email</Label>
                    <Input {...editProps("email")} value={email} width={466} />
                    <Label grow>Pref</Label>
                    <Input {...editProps("communication_preference")} maxLength={3} value={communication_preference} width={40} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label shrink={false} width={37}>Addr1</Label>
                    <Input {...editProps("address_1")} value={address_1} maxLength={35} width={363} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label shrink={false} width={37}>Addr2</Label>
                    <Input {...editProps("address_2")} value={address_2} maxLength={35} width={363} />

                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>City</Label>
                    <Input grow {...editProps("city")} value={city} maxLength={21} width={363} />

                    <Label width={30}>Prov</Label>
                    <Input shrink={false} {...editProps("province")} value={province} uppercase maxLength={2} width={50} />
                    <Label width={20}>PC</Label>
                    <Input shrink={false} {...editProps("postal_code")} value={postal_code} uppercase maxLength={10} width={105} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label shrink={false} width={37}>Ctry</Label>
                    <Input {...editProps("country")} value={country} uppercase maxLength={12} width={233} />
                    <Label style={{ "fontSize": "14px", "textAlign": "left" }} width={171}><nobr><em><a><CopyIcon />&nbsp; Copy Address</a></em></nobr></Label>
                    <Label grow><nobr>OL Act#</nobr></Label>
                    <Input {...editProps("san")} value={san} maxLength={7} width={87} />
                    <Label width={20}>Rep</Label>
                    <Input {...editProps("rep")} value={rep} uppercase maxLength={4} width={45} />
                </Space>
                <div className="shim" />
                <Space grow size={8}>
                    <Label shrink={false} width={37}>Class</Label>
                    <Input {...editProps("interest_1")} value={interest_1} maxLength={8} width={107} />
                    <Input {...editProps("interest_2")} value={interest_2} maxLength={8} width={107} />
                    <Input {...editProps("interest_3")} value={interest_3} maxLength={8} width={107} />
                    <Input {...editProps("interest_4")} value={interest_4} maxLength={8} width={107} />
                    <Label style={{ "fontSize": "14px", "textAlign": "right" }} width={176}><nobr><em><a>Shipping Addresses</a></em></nobr></Label>
                </Space>
            </>
        )
    }

    const thisYear = dayjs().year();
    const lastYear = thisYear - 1;
    const prevYear = thisYear - 2;


    const drawExtra = () => {
        return (
            <>
                <Space grow style={{ alignItems: "start" }}>
                    <div style={{ "width": "100%" }}>
                        <Space grow size={8}>
                            <Label width={37}>BillTo</Label>
                            <Input grow {...editProps("bill_to")} value={bill_to} width={200} />
                        </Space>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Space size={8}>
                            <Label width={57}>Discount</Label>
                            <Space size={3}>
                                <Input {...editProps("discount")} value={discount} number maxLength={2} warning width={25} />
                                <Label>%</Label>
                            </Space>
                            <Label grow><nobr>A/R Total</nobr></Label>
                            <Input value="?" black width={60} />
                            <Input warning value="?" width={42} />
                        </Space>
                        <div className="shim" />
                        <Space size={8}>
                            <Label width={57}><nobr>Tax Code</nobr></Label>
                            <Input {...editProps("tax_group_code")} maxLength={4} value={tax_group_code} width={60} />
                            <Label grow shrink width={0}>CreditLim</Label>
                            <Input {...editProps("credit_limit")} number maxLength={6} value={credit_limit} width={60} />

                        </Space>
                        <div className="shim" /><div className="shim" /><div className="shim" />
                        <Space size={8}>
                            <Label width={35}><nobr>Tax#1</nobr></Label>
                            <Input grow {...editProps("tax_exempt")} value={tax_exempt} maxLength={10} width={90} />
                            <Label width={40}><nobr>Ship</nobr></Label>
                            <Input {...editProps("ship_via")} value={ship_via} width={120} />
                        </Space>
                        <div className="shim" />
                        <Space size={8}>
                            <Label width={35}><nobr>Tax#2</nobr></Label>
                            <Input grow {...editProps("tax_exempt_2")} value={tax_exempt_2} maxLength={10} width={90} />
                            <Label width={40}><nobr>Terms</nobr></Label>
                            <Input value={term} width={120} />
                        </Space>
                        <div className="shim" />
                        <Space size={8}>
                            <Label width={35}><nobr>Card#</nobr></Label>
                            <Input grow value="1234567890" width={200} />
                        </Space>
                    </div>
                    <div>
                        <Card style={{ "width": "226px" }} secondary>
                            <Space size={8}>
                                <Label width={100}><nobr>Acct Created</nobr></Label>
                                <Input value={enter_date} medium black width={100} />
                            </Space>
                            <div className="shim" />
                            <Space size={8}>
                                <Label width={100}><nobr>Last Active</nobr></Label>
                                <Input value={last_order_date} medium width={100} />
                            </Space>
                            <div className="shim" /><div className="shim" style={{ "height": "6px" }} />
                            <Space size={3}>
                                <Label width={66}><nobr>Sales '{String(prevYear).slice(2)}</nobr></Label>
                                <Label width={66}><nobr>{lastYear}</nobr></Label>
                                <Label width={66}><nobr>{thisYear}</nobr></Label>
                            </Space>
                            <Space size={3}>
                                <Input value={drawPrice(sales_3)} right medium black width={66} />
                                <Input value={drawPrice(sales_last)} right medium black width={66} />
                                <Input value={drawPrice(sales_this)} right medium black width={66} />
                            </Space>
                        </Card>
                        <div className="shim" />
                        <Card style={{ "width": "225px" }} secondary>
                            <Label style={{ "textAlign": "center" }}>Frequent Buyer Status</Label>
                            <div className="shim" /><div className="shim" />
                            <Space size={8}>
                                <Label width={60}>Enabled?</Label>
                                <Input medium value={(frequent_buyer) ? "Yes" : "No"} width={25} />
                                <Label width={10}>$</Label>
                                <Input medium warning value={((isNaN(frequent_buyer_point) || frequent_buyer_point === 0) ? "0" : drawPrice(frequent_buyer_point/100))} width={65} />
                            </Space>
                            <div className="shim" />
                        </Card>
                    </div>
                </Space>
                <div className="shim" /><div className="shim" style={{ "height": "8px" }} />
                <Space size={8}>
                    <Label width={35}><nobr>Notes</nobr></Label>
                    <Input grow value={note} width={203} />
                    <Label width={95}><nobr>Combine POs?</nobr></Label>
                    <Input value={combine_po} width={14} />
                </Space>
                <div className="shim" />
                <Space size={8}>
                    <Label width={35}><nobr></nobr></Label>
                    <Input grow value="" width={203} />
                    <Label width={95}><nobr>Get Deposit?</nobr></Label>
                    <Input value={(get_deposit) ? "Y" : "N"} width={14} />
                </Space>
            </>
        )
    }

    return (
        <div className="customer-card">
            <Row>
                <Row.Item flexShrink={1} flexGrow={1} minWidth={"570px"} width="626px" >
                    {drawCard()}
                </Row.Item>
                <div style={{ maxWidth: "20px", flexGrow: 1 }}></div>
                <Row.Item flexShrink={1} flexGrow={1} width="612px" >
                    {drawExtra()}
                </Row.Item>
            </Row>
        </div>
    )
}